import MonthYearPicker from '@/components/selector/month-year-picker/month-year-picker';
import { DrillDownModel } from '@/models/drill-down/drill-down';
import { ClassCompetencyData } from '@/models/groups/class';
import { PerformanceData } from '@/models/groups/performance';
import { ReportData, StruggleData } from '@/models/groups/report';
import { SubjectModel } from '@/models/groups/subjects';
import { ClassTimespentData, TimespentData } from '@/models/groups/timespent';
import { UsersData } from '@/models/groups/users';
import DrilldownList from '@/routers/views/network/drill-down/drilldown-list/drilldown-list';
import DrilldownPerformance from '@/routers/views/network/drill-down/drilldown-performance/drilldown-performance';
import moment from 'moment';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'group-competency-report',
    components: {
        'drill-down-report': () => import('@/routers/views/network/drill-down/drilldown-chart/drill-down-chart'),
        'drilldown-list': DrilldownList,
        'drilldown-performance': DrilldownPerformance,
        'month-picker': MonthYearPicker,
    },
})
export default class GroupCompetencyReport extends Vue {

    private get drilldown() {
        return this.competencyData && this.groupType !== 'class'
            ? this.competencyData.drilldown : (this.classCompetencyData.drilldown || []);
    }

    private get coordinateData() {
        return this.competencyData && this.groupType !== 'class' ? this.competencyData.coordinates : [];
    }

    private get performanceDrilldown() {
        return this.performanceData && this.groupType !== 'class'
            ? this.performanceData.drilldown : (this.classCompetencyData.drilldown || []);
    }

    private get performanceCoordinateData() {
        return this.performanceData && this.groupType !== 'class' ? this.performanceData.coordinates : [];
    }

    private get timespentDrilldown() {
        return this.timespentData && this.groupType !== 'class'
            ? this.timespentData.drilldown : (this.classCompetencyData.drilldown || []);
    }

    private get timespentCoordinate() {
        return this.timespentData && this.groupType !== 'class' ? this.timespentData.coordinates : [];
    }

    private get userDrilldown() {
        return this.usersDrillDownData && this.groupType !== 'class'
            ? this.usersDrillDownData.drilldown : [];
    }

    private get userCoordinate() {
        return this.usersDrillDownData && this.groupType !== 'class' ? this.usersDrillDownData.coordinates : [];
    }

    private get struggleCompList() {
        const strugglingCompetencies = this.strugglingCompetencies;
        return strugglingCompetencies.map((competency: StruggleData) => competency.competencies).flat(1);
    }


    @Prop()
    public performanceData!: PerformanceData;

    @Prop()
    public timespentData!: TimespentData;

    @Prop()
    public classTimespentData!: ClassTimespentData;

    // --------------–––––––––––––––––----------------------------------------
    // Properties

    @Prop()
    private groupType!: string;

    @Prop()
    private breadcrumbItems?: Array<{id: number, name: string, type: string}> ;

    @Prop()
    private studentList: any;

    @Prop()
    private competencyData!: ReportData;

    @Prop({default: ''})
    private entityName: any;

    @Prop()
    private frequency!: string;

    @Prop()
    private classCompetencyData!: ClassCompetencyData;

    @Prop()
    private activeMonth!: string;

    @Prop()
    private activeYear!: string;

    @Prop()
    private isLoading!: boolean;

    @Prop()
    private subjectList: any;

    @Prop()
    private tenantSettings: any;

    @Prop()
    private stubData!: any;

    @Prop()
    private groupId!: string;

    @Prop()
    private countryData: any;
    @Prop()
    private selectedDate: any;
    @Prop()
    private subjectsList?: SubjectModel[];

    @Prop()
    private seletedLevel?: DrillDownModel;
    @Prop()
    private cardDetails: any;

    @Prop()
    private isDemoTenant!: boolean;
    @Prop()
    private isAtInitialLevel!: boolean;


    @Prop({default: false})
    private isRestrictClass!: boolean;

    @Prop()
    private usersDrillDownData!: UsersData;

    @Prop({default: []})
    private strugglingCompetencies!: StruggleData[];

    @Prop()
    private groupStubData: any;

    private tableFields: any = [
        {
            label: 'Name',
            key: 'name',
        },
        {
            label: 'Gained Competency',
            key: 'masteredCompetencies',
        },
    ];

    private coordinateFields: any = [
        {
            label: 'Date (YYYY-MM-DD)',
            key: 'label',
        },
        {
            label: 'Gained Competency',
            key: 'masteredCompetencies',
        },
    ];

    private performanceFields: any = [
        {
            label: 'Name',
            key: 'name',
        },
        {
            label: 'Average Performance',
            key: 'averagePerformance',
        },
    ];

    private performanceCooridate: any = [
        {
            label: 'Date (YYYY-MM-DD)',
            key: 'label',
        },
        {
            label: 'Averge performance',
            key: 'averagePerformance',
        },
    ];

    private timespentFields: any = [
        {
            label: 'Name',
            key: 'name',
        },
        {
            label: 'Average Timespent',
            key: 'overallAverageTimespent',
        },
    ];

    private timespentCoordiateFieds: any = [
        {
            label: 'Date (YYYY-MM-DD)',
            key: 'label',
        },
        {
            label: 'Average Timespent',
            key: 'totalCollectionTimespent',
        },
    ];

    private userFields: any = [
        {
            label: 'Name',
            key: 'name',
        },
        {
            label: 'Teacher Count',
            key: 'totalTeachers',
        },
        {
            label: 'Student Count',
            key: 'totalStudents',
        },
    ];

    private userCoordinateFields: any = [
        {
            label: 'Date (YYYY-MM-DD)',
            key: 'label',
        },
        {
            label: 'Total Users',
            key: 'totalUsers',
        },
    ];

    private struggleFields: any = [
        {
            label: 'Display Code',
            key: 'compDisplayCode',
        },
        {
            label: 'Domain Name',
            key: 'domainName',
        },
        {
            label: 'Competency Name',
            key: 'compName',
        },
    ];


    // --------------------------------------------------------------------------
    // Hooks

    // --------------------------------------------------------------------------
    // Methods

    private getDate(label: number) {
        return moment(`${this.activeYear}-${this.activeMonth}-${label}`, 'YYYY-MM-DD').format('LL');
    }

    private averageTimespent(timepsentData: any) {
        const { averageAssessmentTimespent, averageCollectionTimespent, averageOaTimespent} = timepsentData;
        return averageAssessmentTimespent + averageCollectionTimespent + averageOaTimespent;
    }

}
